export enum LoadingState {
  init,
  loading,
  success,
  error,
}
